module.exports = __webpack_public_path__ + "media/images/donation/how-to-use2-77feffd98e8cfc49fe9c42b7e13e0d83.jpg";